var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},_vm._l((_vm.docs),function(travel){return _c('travel-tile',{key:travel._id,attrs:{"travel":travel}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }